import { expVal } from '@atlassian/jira-feature-experiments';

const NinCaterRichTextWithPlainTextRendererRelayProvider = {
	get(): boolean {
		return expVal('nin_handle_rich_text_with_plain_text_renderer', 'isEnabled', false);
	},
};

export default NinCaterRichTextWithPlainTextRendererRelayProvider;
